module.exports = {
  email: 'miseongk9@gmail.com',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/MiseongKwon',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/miseong-kwon-b546b926/',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/ideascript',
    },
    {
      name: 'Codepen',
      url: 'https://codepen.io/miseongkwon',
    },
    {
      name: 'Email',
      url: 'mailto:miseongk9@gmail.com',
    },
  ],

  navLinks: [
    {
      name: 'ABOUT',
      url: '/#about',
    },
    {
      name: 'PROJECTS',
      url: '/#projects',
    },
    {
      name: 'LEARNING LOG',
      url: '/learning-log',
    },
    {
      name: 'CONTACT',
      url: '/#contact',
    },
  ],

  colors: {
    purple: '#d175ff',
    navy: '#131f45',
    darkNavy: '#111932',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
